<div class="container mx-auto !p-0 transfers">
  <app-spinner [spinnerId]="'fullpage'"></app-spinner>
  <!--
  <pre>{{conditions | json}}</pre>
  -->

  <div class="user-info w-full mb-8 mx-auto relative min-h-[100px]" [ngClass]="{ 'lg:w-[40%]': kycValid }">
    <app-spinner [spinnerId]="'spinnerProfile'"></app-spinner>
    <div class="flex gap-4 items-center" *ngIf="!(spinnerStates['spinnerProfile'] | async)">
      <div class="flex gap-4 w-[50%]" [ngClass]="{'w-[50%]': !kycValid, 'w-full': kycValid}">
        <img class="mt-1" [src]="'https://cdn.zendy.tel/images/image_profile_'+(kycValid ? 'ok' : 'ko')+'.svg'" />
        <div *ngIf="kycValid">
          <div class="flex items-center">
            <p>{{ 'TRANSFERS.PROFILE.OK.TITLE' | translate }}</p> <mat-icon class="!text-[20px] !size-[20px] text-green-700 ml-2">check_circle</mat-icon>
          </div>
          <p class="font-bold">{{ 'TRANSFERS.PROFILE.OK.SUBTITLE' | translate }}</p>
        </div>
        <div *ngIf="!kycValid">
          <p>{{ 'TRANSFERS.PROFILE.KO.TITLE' | translate }}</p>
          <div class="flex items-center mb-2">
            <p class="font-bold text-red-700">{{ 'TRANSFERS.PROFILE.KO.SUBTITLE' | translate }}</p> <mat-icon class="!text-[20px] !size-[20px] text-red-500 ml-2">error</mat-icon>
          </div>
          <p class="font-bold ">{{ 'TRANSFERS.PROFILE.KO.TEXT' | translate }}</p>
        </div>
      </div>

      <div class="w-[50%] mb-2" [ngClass]="{'hidden': kycValid}">
        <div *ngIf="!email" class="flex gap-4 items-center mb-2" [formGroup]="firstFormGroup">
          <mat-form-field class="calls-full-width mx-0">
            <mat-label>{{ 'TRANSFERS.EMAIL' | translate }}</mat-label>
            <input formControlName="email"
                   type="email"
                   matInput />
          </mat-form-field>
        </div>
        <div *ngIf="!kycValid && kycUrl" class="flex gap-4 items-center">
          <!--<app-button (click)="window.open(kycUrl, '_blank')" hasIcon="hasIcon" color="secondary" class="bg-transparent"><mat-icon class="!text-[30px] !size-[30px] cursor-pointer text-red-700">add_a_photo</mat-icon> {{ "TRANSFERS.VALIDATE_KYC_TEXT" | translate }}</app-button>-->
          <app-button (click)="checkKycValidity()" hasIcon="hasIcon" color="secondary" class="bg-transparent"><mat-icon class="!text-[30px] !size-[30px] cursor-pointer text-red-700">add_a_photo</mat-icon> {{ "TRANSFERS.VALIDATE_KYC_TEXT" | translate }}</app-button>
        </div>
      </div>
    </div>
  </div>

  <mat-stepper [linear]="true" #stepper class="custom-stepper" (selectionChange)="onStepChange($event)">

    <!-- STEP 1 -->
    <mat-step [formGroup]="firstFormGroup">

      <div>
        <h3 class="text-center mt-4">{{ "TRANSFERS.CALCULATE_QUOTATION" | translate }}</h3>
        <p class="text-center mb-4">{{ "TRANSFERS.SELECT_FOR_QUOTATION" | translate }}</p>

        <div class="grid gap-4 grid-cols-1 lg:grid-cols-2 mb-4">
          <div class="amount-container w-full items-center">
            <div class="text-center w-full pt-2 font-semibold text-sm">{{ "TRANSFERS.WANT_PAY" | translate }}</div>

            <div class="flex-col gap-4 w-full px-6">
              <div class="flex justify-between gap-4 w-full">

                <!-- Modo edición -->
                <mat-form-field *ngIf="isEditing"
                                class="!hover:bg-transparent flex !p-0 !m-0">
                  <input matInput
                         type="number"
                         formControlName="amount"
                         (blur)="stopEditing()"
                         (input)="onAmountInput()"
                         placeholder="100"
                         class="font-semibold !text-[30px]" />
                </mat-form-field>

                <!-- Modo visual -->
                <div *ngIf="!isEditing"
                     class="font-semibold text-[30px] cursor-pointer px-0 py-6 flex items-center justify-between hover:bg-gray-100 w-full"
                     (click)="editAmount()"
                     style="border-bottom: 1px solid black"
                >
                  {{ formattedAmount || "TRANSFERS.WANT_PAY" | translate }}
                </div>

                <!-- Flag y moneda -->
                <div class="flex gap-2 items-center w-fit">
                  <img [src]="'https://flagcdn.com/eu.svg'" width="50" class="flag-icon" />
                  EUR
                </div>
              </div>

              <!-- Validación -->
              <div class="w-full" *ngIf="firstFormGroup.get('amount')?.touched && firstFormGroup.get('amount')?.invalid">
                <small class="text-red-500" *ngIf="firstFormGroup.get('amount')?.errors?.['required']">
                  {{ 'COMMON.REQUIRED' | translate }}
                </small>
                <small class="text-red-500" *ngIf="firstFormGroup.get('amount')?.errors?.['max']">
                  {{ "TRANSFERS.ALERT_MAX_MSG" | translate:{ max: (firstFormGroup.get('amount')?.errors?.['max']['max'] | formatNumberEs:{ style: 'currency', currency: 'EUR' } ) } }}
                </small>
              </div>

            </div>
          </div>

          <div class="amount-container w-full">
            <div class="text-center pt-2 w-full font-semibold text-sm">{{ "TRANSFERS.RECEIVE" | translate }}</div>

            <div class="select-container flex flex-col lg:flex-row items-center justify-center lg:justify-between pt-4 gap-4 lg:text-left text-center">
              <div class="w-full font-semibold !text-[30px] pl-4" *ngIf="spinnerStates['spinnerQuot'] | async">
                <app-spinner [spinnerId]="'spinnerQuot'"></app-spinner>
              </div>
              <div class="w-full font-semibold !text-[30px] pl-4" *ngIf="!(spinnerStates['spinnerQuot'] | async)">{{ quotation?.receive_amount | formatNumberEs:{ style: 'currency', currency: quotation?.receive_currency } }}</div>

              <div class="flex gap-2 items-center mr-4">
                <app-spinner [spinnerId]="'spinnerCountries'"></app-spinner>
                <div class="" *ngIf="!(spinnerStates['spinnerCountries'] | async)"><img [src]="'https://flagcdn.com/'+countryinfo?.countryCode?.toLowerCase()+'.svg'" width="90" alt="{{ countryinfo?.country }}" class="country-flag mr-2"></div>
                <mat-select *ngIf="!(spinnerStates['spinnerCountries'] | async)" #mySelect accesskey="" formControlName="selectedCountry" class="p-2 rounded text-black" [panelClass]="'custom-select-panel'" (openedChange)="onOpenChange(mySelect)">
                  <!--<input (keyup)="onKey($event)" placeholder="{{ 'TRANSFERS.COUNTRY_PLACEHOLDER' | translate }}" class="w-full p-2 rounded bg-white text-black">-->
                  <mat-option value="" selected class="!hidden">{{ 'TRANSFERS.SELECT_COUNTRY' | translate }}</mat-option>
                  <mat-option *ngFor="let country of filteredCountriesFull" [value]="country.iso3">
                    <div class="flex items-center">
                      <img [src]="'https://flagcdn.com/'+country.countryCode.toLowerCase()+'.svg'" width="30" alt="{{ country.country }}" class="country-flag mr-4">
                      <span>{{ country.iso3 }}</span>
                    </div>
                  </mat-option>
                </mat-select>
              </div>

            </div>

          </div>
        </div>

        <div class="grid gap-4 grid-cols-1 lg:grid-cols-2 mb-4">
          <mat-form-field class="select-container w-full bg-neutral-100 ">
            <mat-select formControlName="selectedProductType" class="p-2 rounded text-black">
              <mat-option value="" selected class="!hidden">{{ 'TRANSFERS.SELECT_PRODUCT_TYPE' | translate }}</mat-option>

              <mat-option *ngFor="let productType of productTypes" [value]="productType">
                <div class="flex items-center">
                  <span>{{ "TRANSFERS."+productType | translate }}</span>
                </div>
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field class="select-container w-full bg-neutral-100 no-bg-input">
            <mat-select formControlName="selectedProduct" class="p-2 rounded text-black">

              <mat-option value="" selected class="!hidden">{{ 'TRANSFERS.SELECT_PRODUCT' | translate }}</mat-option>

              <mat-option *ngFor="let product of filteredProducts" [value]="product.id">
                <div class="flex items-center">
                  <span>{{ product.agent }} ({{product.currency}})</span>
                </div>
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <hr />

      <h2>{{ "TRANSFERS.PAYMENT_METHOD" | translate }}</h2>
      <!--
      <mat-radio-group formControlName="payment_method" class="flex lg:flex-row  gap-8">
        <mat-radio-button value="PAYMENT_CARD">
          <div class="flex items-center"><mat-icon class="text-neutral-400 text-[50px] !size-[50px] mr-4 material-icons-outlined">credit_card</mat-icon>{{ 'TRANSFERS.PAYMENT_CARD' | translate }}</div>
        </mat-radio-button>
        <mat-radio-button value="PAYMENT_ACCOUNT" *ngIf="paylands?.allow_direct">
          <div class="flex items-center"><mat-icon class="text-neutral-400 text-[50px] !size-[50px] mr-4 material-icons-outlined">assured_workload</mat-icon>{{ 'TRANSFERS.PAYMENT_ACCOUNT' | translate }}</div>
        </mat-radio-button>
      </mat-radio-group>
      -->
      <mat-radio-group formControlName="payment_method" class="flex lg:flex-row flex-col gap-16 justify-center mb-16">
        <mat-radio-button class="!hidden" value="PAYMENT_CARD" #cardRef="matRadioButton"></mat-radio-button>
        <label class="cursor-pointer flex flex-col items-center text-center border rounded-2xl p-4 transition hover:shadow-md"
               [ngClass]="{'border-red-700 ring-2 ring-red-700/50': firstFormGroup.get('payment_method')?.value === 'PAYMENT_CARD','border-neutral-300': firstFormGroup.get('payment_method')?.value !== 'PAYMENT_CARD'}"
               (click)="cardRef.checked = true; firstFormGroup.get('payment_method')?.setValue('PAYMENT_CARD')">
          <mat-icon class="text-neutral-400 !text-[50px] !size-[50px] mb-4">credit_card</mat-icon>
          {{ 'TRANSFERS.PAYMENT_CARD' | translate }}
        </label>

        <ng-container *ngIf="paylands?.allow_direct">
          <mat-radio-button class="!hidden" value="PAYMENT_ACCOUNT" #accountRef="matRadioButton"></mat-radio-button>
          <label class="cursor-pointer flex flex-col items-center text-center border rounded-2xl p-4 transition hover:shadow-md"
                 [ngClass]="{'border-red-700 ring-2 ring-red-700/50': firstFormGroup.get('payment_method')?.value === 'PAYMENT_ACCOUNT','border-neutral-300': firstFormGroup.get('payment_method')?.value !== 'PAYMENT_ACCOUNT'}"
                 (click)="accountRef.checked = true; firstFormGroup.get('payment_method')?.setValue('PAYMENT_ACCOUNT')">
            <mat-icon class="text-neutral-400 !text-[50px] !size-[50px] mb-4">assured_workload</mat-icon>
            {{ 'TRANSFERS.PAYMENT_ACCOUNT' | translate }}
          </label>
        </ng-container>
      </mat-radio-group>



      <div id="quotation" class="mt-6 mb-10 w-full my-6 p-4 mx-auto relative border rounded-md border-red-700">
        <h3 class="text-red-700 font-bold text-center">{{ "TRANSFERS.CONVERSION" | translate }}</h3>
        <div *ngIf="quotation">
          <!--
          <p>fee: {{quotation.fee}}</p>
          <p>revenue: {{quotation.revenue}}</p>
          {{quotation.fee}} + {{quotation.revenue}} = {{quotation.fee + quotation.revenue}}
          -->

          <hr class="mb-4" />
          <div class="flex gap-4 justify-between w-full font-medium mb-4 items-center">
            <div>{{ "TRANSFERS.EXCHANGE_RATE" | translate }}</div><div>{{ 1 | formatNumberEs:{ style: 'currency', currency: quotation.receive_currency } }} = {{ quotation.exchange_rate }} €</div>
          </div>
          <div class="flex gap-4 justify-between w-full font-medium items-center" [ngClass]="{'mb-2': !noFee, 'mb-4': noFee}">
            <div>{{ "TRANSFERS.COMISIONS" | translate }}</div><div><span [ngClass]="{'line-through': noFee, 'text-red-700': noFee}">{{ ( quotation.fee + quotation.revenue ) | formatNumberEs:{ style: 'currency', currency: selectedCurrency } }}</span> <span *ngIf="noFee" class="font-sbold text-xl ml-2">{{ 0 | formatNumberEs:{ style: 'currency', currency: selectedCurrency } }}</span></div>
          </div>
          <div class="flex gap-4 justify-between w-full font-medium items-center">
            <div>{{ "TRANSFERS.TOTAL" | translate }}</div><div class="text-xl">{{ ( noFee ? quotation.send_amount : quotation.total_due + quotation.revenue ) | formatNumberEs:{ style: 'currency', currency: selectedCurrency } }}</div>
          </div>
        </div>
        <app-spinner [spinnerId]="'spinnerQuot'"></app-spinner>
      </div>

      <div *ngIf="quotation?.differs_from_requested_amount" class="mt-6 mb-10 w-[60%] p-4 mx-auto relative border rounded-md border-amber-500 justify-between items-center flex gap-4">
        <div><mat-icon class="text-amber-500 text-[50px] !size-[50px]">report</mat-icon></div>
        <div>
          <p>{{ "TRANSFERS.ALERT_MSG" | translate }}</p>
          <ul>
            <li *ngIf="product.min_amount">
              {{ "TRANSFERS.ALERT_MIN_MSG" | translate:{ min: (product.min_amount | formatNumberEs:{ style: 'currency', currency: product.currency } ) } }}
            </li>
            <li *ngIf="product.max_amount">
              {{ "TRANSFERS.ALERT_MAX_MSG" | translate:{ max: (product.max_amount | formatNumberEs:{ style: 'currency', currency: product.currency } ) } }}
            </li>
            <li *ngIf="product.multiple_of">
              {{ "TRANSFERS.ALERT_MULTIPLE_MSG" | translate:{ multiple: (product.multiple_of | formatNumberEs:{ style: 'currency', currency: product.currency } ) } }}
            </li>
          </ul>
        </div>
      </div>


      <!--
      {{quotation | json}}
      {{ paylands | json }}
      -->

      <div class="flex justify-center mt-6 mb-10">
        <app-button (click)="nextstep()" color="primary" [disabled]="!firstFormGroup.valid || !kycValid">{{ "COMMON.NEXT" | translate }}</app-button>
      </div>
    </mat-step>



    <!-- STEP 2 -->
    <mat-step [stepControl]="secondFormGroup">
      <app-beneficiary-form *ngIf="product" (messageEvent)="receiveMessage($event)" [regions]="regions" [product]="product" [filteredCountries]="filteredCountries" [selectedCountry]="selectedCountry" [fixedTextPatterns]="fixedTextPatterns"></app-beneficiary-form>

      <h2>{{ "TRANSFERS.PAYMENT_METHOD" | translate }}</h2>

      <!--
      <mat-radio-group [(ngModel)]="payment_method" class="flex flex-col gap-2">
        <mat-radio-button value="PAYMENT_CARD">{{ 'TRANSFERS.PAYMENT_CARD' | translate }}</mat-radio-button>
        <mat-radio-button value="PAYMENT_ACCOUNT" *ngIf="paylands?.allow_direct">{{ 'TRANSFERS.PAYMENT_ACCOUNT' | translate }}</mat-radio-button>
      </mat-radio-group>
      -->

      <ng-container *ngIf="payment_method === 'PAYMENT_CARD'">

        <!--
        <hr class="my-4" />
        -->

        <mat-radio-group [(ngModel)]="cardId" class="flex flex-col gap-2">
          <mat-radio-button [value]="">
            <div class="flex items-center"><mat-icon class="text-[30px] !size-[30px] mr-4">add_card</mat-icon>{{ "TRANSFERS.NEW_CARD" | translate }}</div>
          </mat-radio-button>
          <ng-container *ngIf="paylands">
            <mat-radio-button *ngFor="let card of paylands?.cards" [value]="card.id">
              <div class="flex items-center">
                <img [src]="getCardLogo(card.card_brand)" width="40" alt="{{ card.card_brand }}" *ngIf="card.card_brand">
                <span class="ml-4">**********{{ card.last4 }}</span>
              </div>
            </mat-radio-button>
          </ng-container>
        </mat-radio-group>
      </ng-container>

      <ng-container *ngIf="payment_method !== 'PAYMENT_CARD'">
        <p>{{ "TRANSFERS.DIRECT_BANKING_MSG" | translate }}</p>
      </ng-container>

      <div class="flex justify-center mt-6 mb-10 gap-4">
        <app-button hasIcon="hasIcon" (click)="prevstep()" color="secondary"><mat-icon>chevron_left</mat-icon>{{ "COMMON.BACK" | translate }}</app-button>
        <app-button (click)="nextstep()" color="primary" [disabled]="!secondFormGroup.valid">{{ "COMMON.NEXT" | translate }}</app-button>
      </div>

    </mat-step>



    <!-- STEP 3 -->
    <mat-step>

      <img class="mx-auto my-2" width="80" [src]="'https://cdn.zendy.tel/images/zendy_ico.svg'" />

      <h2 class="font-bold text-center text-black">{{ "TRANSFERS.SUMMARY" | translate }}</h2>
      <p class="text-center my-4">{{ "TRANSFERS.SUMMARY_SUBTITLE" | translate }}</p>
      <p class="text-center my-4 text-sm">{{ "TRANSFERS.SUMMARY_P" | translate }}</p>

      <div class="my-6 py-4 px-4 lg:px-16 mx-auto w-full lg:w-[60%] relative border rounded-md border-red-700">
        <h3 class="text-red-700 font-bold text-center">{{ "TRANSFERS.SUMMARY" | translate }}</h3>
        <div *ngIf="quotation">
          <hr class="mb-4" />
          <div class="flex gap-4 justify-between w-full font-medium mb-4 items-center">
            <div>{{ "TRANSFERS.EXCHANGE_RATE" | translate }}</div><div>1 € = {{ quotation.exchange_rate }} {{ quotation.receive_currency }}</div>
          </div>
          <div class="flex gap-4 justify-between w-full font-medium items-center" [ngClass]="{'mb-2': !firstSend, 'mb-4': firstSend}">
            <div>{{ "TRANSFERS.COMISIONS" | translate }}</div>
            <div>
              <span [ngClass]="{'line-through': firstSend, 'text-red-700': firstSend}">
                {{ (quotation.fee + quotation.revenue) | formatNumberEs:{ style: 'currency', currency: selectedCurrency } }}
              </span>
              <span *ngIf="firstSend" class="font-sbold text-xl ml-2">
                {{ 0 | formatNumberEs:{ style: 'currency', currency: selectedCurrency } }}
              </span>
            </div>
          </div>
          <div class="flex gap-4 justify-between w-full font-medium items-center">
            <div>{{ "TRANSFERS.TOTAL" | translate }}</div><div>{{ finalPrice | formatNumberEs:{ style: 'currency', currency: selectedCurrency } }}</div>
          </div>
        </div>

          <div class="w-[50%] font-medium items-center text-center ng-star-inserted grid justify mx-auto" *ngIf="!firstSend">
            <app-promo product="transfers"></app-promo>
            <div *ngIf="priceBeforePromo" class="flex gap-2 float-end items-baseline"><i>{{ "COMMON.PROMO.DISCOUNT_TEXT" | translate }}</i><span class="line-throug text-xl">{{ priceBeforePromo | currency:'EUR':'symbol':'1.2-2':'es-ES' }}</span></div>
          </div>
      </div>

      <div class="check-full-width my-4 text-left lg:text-center" *ngIf="payment_method == 'PAYMENT_CARD'">
        <mat-checkbox [(ngModel)]="save_card">{{ 'TRANSFERS.SAVE_CARD' | translate }}</mat-checkbox>
      </div>

      <div class="flex justify-center mt-12 mb-10 gap-4">
        <app-button hasIcon="hasIcon" (click)="prevstep()" color="secondary"><mat-icon>chevron_left</mat-icon>{{ "COMMON.BACK" | translate }}</app-button>
        <app-button hasIcon="hasIcon" [disabled]="transferGoing" (click)="submitTransfer()" color="primary"><mat-icon>send</mat-icon>{{ "TRANSFERS.SUBMIT" | translate }}</app-button>
      </div>

    </mat-step>

  </mat-stepper>

</div>
